<template>

    <div class="account-login booking-container">



        <div class=" has-shadow  mb-5 w-100">
            <div class="row">
                <div class="col-24 col-xl-12 bd-r bg-white">
                    <div class=" pt-8 pb-4 px-7 py-xl-5">
                        <div v-if="error" class="mb-3">

                            <info-box v-bind:type="'error'">
                                <template v-slot:body>
                                    <span class="heading">
                                        Error

                                    </span>

                                    <div v-if="errorText.length">
                                        <p>
                                            {{errorText}}
                                        </p>
                                    </div>
                                </template>
                            </info-box>
                        </div>

                        <div v-if="!error && passwordReset">

                            <info-box v-bind:type="'success'">
                                <template v-slot:body>
                                    <span class="heading">
                                        Success

                                    </span>

                                    <div>
                                        <p>
                                            Your password has been changed successfully. Please login below.
                                        </p>
                                    </div>
                                </template>
                            </info-box>
                        </div>

                        <div v-if="!error && accountCreated">

                            <info-box v-bind:type="'success'">
                                <template v-slot:body>
                                    <span class="heading">
                                        Success

                                    </span>

                                    <div>
                                        <p>
                                            Your account has been created successfully. Please login below.
                                        </p>
                                    </div>
                                </template>
                            </info-box>
                        </div>


                        <div class="btn-container btn-container--start mt-4 mb-4 login-buttons">
                            <span class="btn btn--slate-blue btn-i btn-bed mb-2">Rockliffe Login</span>
                            <a class="btn btn--white btn-i btn-flag btn-golf mb-2" target="_blank" href="https://online-ng.premiersoftware.co.uk/RockliffeHall/Account/Login?authProvider=BackendSystem&ReturnUrl=%2FRockliffeHall%2FGolf%2FMember">Golf Member Login</a>
                        </div>

                        <Form @submit="onSubmit" :validation-schema="schema">
                            <div class="form-group row mb-3">
                                <div class="col-24">
                                    <label for="username" class="form-label">Email address</label>
                                    <Field name="username" class="form-control"></Field>
                                    <ErrorMessage name="username" class="error-message" />
                                </div>
                            </div>

                            <div class="form-group">

                                <div class="form-group row">
                                    <div class="col-24">

                                        <label for="password" class="form-label">Password</label>
                                        <Field name="password" class="form-control" type="password"></Field>
                                        <ErrorMessage name="password" class="error-message" />
                                        <div class="forgot-password">Forgot your password? <a href="/account/#/password-reset">Get Reminder</a></div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group mt-5">
                                <div class="btn-container btn-container--start">

                                    <div class="d-flex flex-row">
                                        <button v-bind:disabled="isLoading" class="btn btn--gold" type="submit">Login</button>
                                        <div v-if="isLoading" style="max-height: 66px; margin-left: 10px;">
                                            <loader></loader>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </Form>

                    </div>
                </div>

                <div class="col-24 col-xl-12 bg-slate-blue account-register-promotion">
                    <div class="pt-4 pb-8 pt-xl-8 px-7">
                        <div class="mb-5">
                            <span class="sub-heading">Don't have a</span>
                            <h3>Rockliffe Account?</h3>
                            <p>You'll miss out on these account benefits:</p>


                            <ul>
                                <li>View all your bookings in one place</li>
                                <li>Easily amend your booking</li>
                                <li>Upgrade your stay</li>

                            </ul>



                            <div class="btn--container">
                                <router-link class="btn btn--transparent btn--highlight" v-bind:to="{name : 'account_register'}">
                                    Create a Rockliffe Account
                                </router-link>
                            </div>
                        </div>



                    </div>
                </div>

            </div>


        </div>
    </div>







</template>

<script>
    import { Field, Form, ErrorMessage } from "vee-validate";
    import * as yup from "yup";
    import Loader from '@/shared/components/Loader.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';

    import { accountStore } from '../store/index';

    export default {
        name: 'AccountLogin',
        components: {
            Field,
            Form,
            ErrorMessage,
            Loader,
            InfoBox
        },
        computed: {
            accountCreated() {
                if (this.$route.query.created != undefined && this.$route.query.created != null && this.$route.query.created == "true") {
                    return true;
                }
                return false;
            },
            passwordReset() {
                if (this.$route.query.reset != undefined && this.$route.query.reset != null && this.$route.query.reset == "true") {
                    return true;
                }
                return false;
            },

        },
        data() {
            const schema = yup.object().shape({
                username: yup.string().required().label("Email address"),
                password: yup.string().required().label("Password"),
            });

            return {
                error: false,
                errorText: '',
                isLoading: false,
                schema
            }
        },
        methods: {
            onSubmit(values) {
                this.isLoading = true;
                var payload = {
                    username: values.username,
                    password: values.password
                };

          

                accountStore.dispatch("login", payload).then(t => {
         
                    accountStore.dispatch("loadSession").then(u => {
                        this.isLoading = false;
                        this.$router.push({ name: 'account_stay_bookings' });
                    });
                }).catch((data) => {
                    this.isLoading = false;

                    if (data.error == "member_migration_initiated") {
                        this.$router.push({ name: 'account_register', query: { email: payload.username } });
                    }


                    if (data.error == "invalid_username_or_password") {
                        this.errorText = "Sorry, an account cannot be found with the details entered.";

                    } else {
                        this.errorText = "Sorry, there has been an error.";

                    }

                    this.error = true;
                });

            }
        }

    }
</script>


<style>
    .account-login {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: auto!important;
        margin-top: 5%;
        margin-bottom: 5%;

    }

    .account-register-promotion {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: white;
    }

        .account-register-promotion * {
            color: white !important;
        }

        .account-register-promotion .sub-heading,
        .account-register-promotion p {
            text-transform: uppercase;
            letter-spacing: 4px;
            font-family: 'Playfair Display';
            font-size: 14px;
        }

        .account-register-promotion p {
            margin-bottom: 40px;
        }

        .account-register-promotion h3 {
            position: relative;
            margin-bottom: 140px;
            font-size: 36px;
            font-family: 'Playfair Display';
        }

            .account-register-promotion h3:after {
                content: '';
                display: block;
                background-color: #a18f5b;
                width: 1px;
                height: 60px;
                bottom: -100px;
                left: 50%;
                position: absolute;
            }

        .account-register-promotion ul {
            padding-left: 0;
            list-style-position: inside;
        }

            .account-register-promotion ul li {
                font-family: Montserrat;
                font-size: 14px;
                margin-bottom: 20px;
                position: relative;
                left: -20px;
            }

    .btn-golf {
        border-color: #425260;
    }



    .account-login a:not(.btn) {
        color: #a18f5b;
        font-weight: bold;
    }


    .account-login .forgot-password {
        margin-top: 15px;
    }

    @media(max-width: 1999px) {
        .account-login {
            display: block !important;
        }
    }
</style>
